import { render, staticRenderFns } from "./ledview.vue?vue&type=template&id=0a5f8632"
import script from "./ledview.vue?vue&type=script&lang=js"
export * from "./ledview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports